import React from "react";

import { Badge, Dropdown, Image } from "react-bootstrap";
import { Table } from "react-bootstrap";

// import CardDropdown from "../../components/CardDropdown";

const TableRow = ({
  data,
  sr,
  viewEntry,
  updateEntry,
  deleteEntry,
  propLength,
}) => {
  return (
    <tr className="text-center">
      <td>{sr}</td>
      {/* <td>
        <Image
          src={data.imageUrl}
          alt="data"
          width={60}
          height={60}
          rounded
          style={{ objectFit: "cover" }}
        />
      </td> */}
      <td style={{ minWidth: "180px" }}>{data.title}</td>
      <td>{data.brand}</td>
      <td>${data.price}</td>
      <td>
        <del>${data.originalPrice}</del>
      </td>
      <td>{data.packSize}</td>
      <td>{data.rating} ⭐</td>
      <td>
        <Badge bg={data.status === "active" ? "success" : "secondary"}>
          {data.status}
        </Badge>
      </td>
      <td>{data.order}</td>
      <td>
        {data.isNewItem ? (
          <Badge bg="info">New</Badge>
        ) : (
          <Badge bg="secondary">
            Old
          </Badge>
        )}
      </td>
      <td className="text-center" style={{ minWidth: "180px" }}>
        <span style={{ cursor: "pointer" }} onClick={() => viewEntry(data)}>
          <i className={"bi bi-eye text-info me-2"}></i>
        </span>
        <span style={{ cursor: "pointer" }} onClick={() => updateEntry(data)}>
          <i className={"bi bi-pen text-warning me-2"}></i>
        </span>
        <span style={{ cursor: "pointer" }} onClick={() => deleteEntry(data)}>
          <i className={"bi bi-trash text-danger"}></i>
        </span>
      </td>
    </tr>
  );
};

const BannersTable = ({ list = [], viewEntry, updateEntry, deleteEntry }) => {
  let i = 1;
  return (
    <Table responsive hover bordered style={{ fontSize: "14px" }}>
      <thead className="text-center align-middle">
        <tr>
          <th className="px-3 text-nowrap">#</th>
          {/* <th className="px-3 text-nowrap">Image</th> */}
          <th className="px-3 text-nowrap">Title</th>
          <th className="px-3 text-nowrap">Brand</th>
          <th className="px-3 text-nowrap">Price</th>
          <th className="px-3 text-nowrap">Original Price</th>
          <th className="px-3 text-nowrap">Pack Size</th>
          <th className="px-3 text-nowrap">Rating</th>
          <th className="px-3 text-nowrap">Status</th>
          <th className="px-3 text-nowrap">Order</th>
          <th className="px-3 text-nowrap">Is New</th>
          <th className="px-3 text-nowrap">Actions</th>
        </tr>
      </thead>
      <tbody>
        {list?.map((entry, index) => (
          <TableRow
            data={entry}
            key={index}
            sr={i++}
            propLength={list?.length}
            viewEntry={viewEntry}
            updateEntry={updateEntry}
            deleteEntry={deleteEntry}
          />
        ))}
      </tbody>
    </Table>
  );
};

export default BannersTable;
